const app = {
  state: {
    headerShow: true,
    isMobile: false,
    // defaultImg: 'this.src="' + require('@assets/images/default-img.png') + '"', // 默认图片
    // defaultHeadImg:
    //   'this.src="' + require('@assets/images/default-head.svg') + '"', // 默认头像
    breadcumbList: {},  // 动态修改面包屑数据
    breadStyleType: '',  // 动态修改面包屑样式  ''白色文字 1黑色文字 2灰色背景
    platform: '',  // 3 微信小程序
    globalInfo: {
      friendLink: [],
      museumInfo: {}
    }  // 全局的信息
  },
  mutations: {
    TOGGLE_HEADER: (state, isShow) => {
      state.headerShow = isShow
    },
    TOGGLE_PLAT: (state, isShow) => {
      state.isMobile = isShow
      console.log('是否为移动端', state.isMobile)
    },
    SET_BREAD: (state, data) => {
      console.log('-----------------')
      state.breadcumbList = data
    },
    SET_BREAD_TYPE: (state, data) => {
      state.breadStyleType = data

      console.log(99, state.breadStyleType)
    },
    SET_PLAT: (state, data) => {
      state.platform = data
    },
    SET_GLOBAL_INFO: (state, data) => {
      state.globalInfo = data
    },
  },
  actions: {
    ToggleHeader({ commit }, isShow) {
      commit('TOGGLE_HEADER', isShow)
    },
    TogglePlat({ commit }, val) {
      commit('TOGGLE_PLAT', val)
    },
    // 改变面包屑
    changeBread({ commit }, data) {
      commit('SET_BREAD', data)
      // state.breadcumbList = data
    },
    changeBreadStyleType({ commit }, data) {
      commit('SET_BREAD_TYPE', data)
    },
    setPlat({ commit }, data) {
      commit('SET_PLAT', data)
    },
    setGlobalInfo({ commit }, data) {
      commit('SET_GLOBAL_INFO', data)
    },
  }
}

export default app
